import styled from 'styled-components';
import { Icon, getTheme, pxToRem } from '~/modules';
import Typography from '../Typography';

const textMain = getTheme('text.main');
const brandPrimaryContrast = getTheme('brand.primary.contrast');
const brandPrimaryLight = getTheme('brand.primary.light');
const brandPrimaryMain = getTheme('brand.primary.main');
const backgroundZ4 = getTheme('background.z4');
const themeRadiusCard = getTheme('themeRadius.card');
const spacingSm = getTheme('spacing.sm');
const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');
const borderRadiusXl = getTheme('borderRadius.xl');

export const Row = styled.div`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

export const Card = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
  align-items: center;
  width: 100%;
  min-height: ${pxToRem(100)};
  padding: 0 ${spacingLg}px;

  background: ${backgroundZ4};
  border-radius: ${themeRadiusCard}px;

  & + & {
    margin-top: ${spacingSm}px;
  }
`;

export const IconCard = styled(Icon)`
  font-weight: 900;
  font-size: ${pxToRem(16)};
  color: ${textMain};
  margin-right: ${spacingMd}px;
`;

export const Text = styled(Typography).attrs({ variant: 'xs' })`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const AccountText = styled(Typography).attrs({ variant: 'xs' })`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Balance = styled(Typography).attrs({ variant: 'xs' })`
  font-weight: bold;
  color: ${textMain};
`;

export const SearchIconBox = styled.div`
  width: ${pxToRem(56)};
  height: ${pxToRem(56)};
  justify-content: center;
  align-items: center;
  border-radius: ${borderRadiusXl}px;
  background: ${(props) =>
    `linear-gradient(180deg, ${brandPrimaryLight(props)} 0%, ${brandPrimaryMain(
      props,
    )} 100%)`};
  cursor: pointer;
`;

export const IconSearch = styled(Icon)`
  font-size: ${pxToRem(24)};
  color: ${brandPrimaryContrast};
  font-weight: 900;
`;
